import { getActiveTenantKey, getTenantScopedKey } from '../offline/tenant'
import { deleteKey, loadJSON, saveJSON } from './storage'
import type { FeedKgDerivationMeta } from './productionFeedKgDerivation'

const STORAGE_KEY_BASE = 'production:feedKgDerivation:v1'

type FeedKgDerivationPayloadV1 = {
  version: 1
  updatedAt: string
  byRowId: Record<string, FeedKgDerivationMeta>
}

const scopedKey = (tenantKey = getActiveTenantKey()): string => getTenantScopedKey(STORAGE_KEY_BASE, tenantKey)

export const loadFeedKgDerivationMetaByRowId = (): Record<string, FeedKgDerivationMeta> => {
  const key = scopedKey()
  const payload = loadJSON<unknown>(key, null)
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    const maybe = payload as Partial<FeedKgDerivationPayloadV1>
    if (maybe.version === 1 && maybe.byRowId && typeof maybe.byRowId === 'object') {
      return maybe.byRowId as Record<string, FeedKgDerivationMeta>
    }
  }
  return {}
}

export const saveFeedKgDerivationMetaByRowId = (byRowId: Record<string, FeedKgDerivationMeta>): void => {
  const key = scopedKey()
  const payload: FeedKgDerivationPayloadV1 = {
    version: 1,
    updatedAt: new Date().toISOString(),
    byRowId
  }
  saveJSON(key, payload)
}

export const clearFeedKgDerivationMeta = (): void => {
  deleteKey(scopedKey())
}
